interface EmptySitePageProps {
  websiteName?: string;
}

export default function EmptySitePage({ websiteName }: EmptySitePageProps) {
  return (
    <main className="empty-site">
      <div className="empty-site__glow empty-site__glow--one" />
      <div className="empty-site__glow empty-site__glow--two" />
      <section className="empty-site__card">
        <div className="empty-site__mark" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
        <p className="empty-site__eyebrow">Website setup in progress</p>
        <h1>{websiteName || 'This website'} is getting ready.</h1>
        <p className="empty-site__copy">
          There are no pages here yet. Content will appear once the first page
          has been created and published.
        </p>
        <div className="empty-site__status">
          <span className="empty-site__status-dot" />
          Website is active
        </div>
      </section>
    </main>
  );
}
